<ul class="breadcrumb">
    <li *ngFor="let link of breadCrumbLinks">
        <ng-container *ngIf="link.routeTo">
            <a (click)="navigate(link.routeTo)"> {{link.name}}</a>
        </ng-container>
        <ng-container *ngIf="!link.routeTo">
            {{link.name}}
        </ng-container>
    </li>
</ul>